import React from 'react';
import ReactDOM from 'react-dom';
import Renewal_Page from '../pages/Renewal_Page';
import Payment_Page from '../pages/Payment_Page';
import Success_paid from '../pages/Success_paid';
import Failure_page from '../pages/Failure_page';
import Expiry_page from '../pages/Expiry_page';
import Payload_not_found from '../pages/Payload_not_found';
import { BrowserRouter as Router,Route,Switch } from 'react-router-dom'




class CUSTRoutes extends React.Component {
     render() {
         return  <Router>
         <div>   
         <Switch>
           <Route exact path="/" component={Renewal_Page} />
           <Route path="/payment" component={Payment_Page} />
           <Route path="/success" component={Success_paid} />
           <Route path="/payload_not_found" component={Payload_not_found} />
           <Route path="/payment_failure" component={Failure_page} />
           <Route path="/expiry" component={Expiry_page} />
            <Route  path='*' exact={true} component={Payload_not_found} />
            </Switch>
         </div>
       </Router>
        
  }
    
   
}

export default CUSTRoutes;